import { DateTime } from 'luxon';

export const clientTZ = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

// Parses a SQLite-naïve timestamp (no Z) or a full ISO. Returns a Date in UTC.
export function parseMaybeDate(s: string | Date | null | undefined): Date | null {
  if (!s) return null;
  if (s instanceof Date) return s;
  if (typeof s !== 'string') return new Date(s);
  const str = s.includes('T') ? s : s.replace(' ', 'T');
  const d = new Date(str);
  return isNaN(d.getTime()) ? null : d;
}

export function formatLocalFromDB(rawDate: string | null, lang: string): string {
  if (!rawDate) return '—';
  const iso = /[Z+-]\d{2}:\d{2}$/.test(rawDate) ? rawDate : rawDate + 'Z';
  const dt = DateTime.fromISO(iso, { zone: 'utc' });
  if (!dt.isValid) return '—';
  return dt
    .setZone(clientTZ)
    .setLocale(lang === 'fr' ? 'fr-CA' : 'en-CA')
    .toLocaleString(DateTime.DATETIME_MED);
}

export function formatLocalHM(dt: Date | null, lang: string): string {
  if (!dt) return '—';
  return dt.toLocaleTimeString(lang === 'fr' ? 'fr-CA' : 'en-CA', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: clientTZ,
  });
}

export function overlaps(aStart: Date, aEnd: Date, bStart: Date, bEnd: Date): boolean {
  return aStart < bEnd && aEnd > bStart;
}

export interface IncidentLike {
  started_at?: string | null;
  started_at_norm_utc?: string | null;
  resolved_at?: string | null;
  resolved_at_norm_utc?: string | null;
}

// Returns 200 (OK), 500 (incident), or null (no data yet).
export function slotStatusFor(
  incidents: IncidentLike[],
  slotStart: Date,
  slotEnd: Date,
): 200 | 500 | null {
  const now = new Date();
  if (slotEnd > now) return null;
  for (const inc of incidents) {
    const st = parseMaybeDate(inc.started_at_norm_utc ?? inc.started_at ?? null);
    const en =
      parseMaybeDate(inc.resolved_at_norm_utc ?? inc.resolved_at ?? null) ?? now;
    if (st && overlaps(st, en, slotStart, slotEnd)) return 500;
  }
  return 200;
}
